import './controls.css';

export interface ToggleOptions {
  value: boolean;
  onChange: (value: boolean) => void;
  ariaLabel?: string;
}

export interface ToggleHandle {
  readonly el: HTMLButtonElement;
  setValue(value: boolean): void;
  destroy(): void;
}

export function createToggle(opts: ToggleOptions): ToggleHandle {
  let value = opts.value;

  const el = document.createElement('button');
  el.type = 'button';
  el.className = 'fg-toggle';
  el.setAttribute('role', 'switch');
  if (opts.ariaLabel) el.setAttribute('aria-label', opts.ariaLabel);
  applyState();

  function applyState() {
    el.classList.toggle('fg-toggle--on', value);
    el.setAttribute('aria-pressed', String(value));
  }

  const handler = () => {
    value = !value;
    applyState();
    opts.onChange(value);
  };
  el.addEventListener('click', handler);

  return {
    el,
    setValue(v) {
      value = v;
      applyState();
    },
    destroy() {
      el.removeEventListener('click', handler);
      el.remove();
    },
  };
}
